import { useTranslation } from 'next-i18next'

import ContainerHomGradientBorder from '~/components/Containers/ContainerHomGradientBorder'
import { Product } from '~/types/product'
import { formatThousands } from '~/utils/helpers'
import { getPrefix } from '~/booking/utils/booking.utils'

export default function PriceItem({ product }: { product: Product }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')

  const price = `${getPrefix(product.currency)} ${formatThousands(product.priceHourly)}`

  return (
    <ContainerHomGradientBorder
      borderThickness={3}
      gradientDirectionCx="bg-gradient-to-br"
      gradientType="tutor-on-demand"
      innerClassName="py-3 text-black"
      outerClassName="shadow-large"
    >
      <div className="space-y-2 flex flex-col text-center items-center font-semibold">
        <span>{t(`landingPage.productPrices.${product.type}`)}</span>
        <span className="pb-2 leading-5 lowercase">
          {price}
          <br />
          {t('landingPage.productPrices.perHour')}
        </span>
      </div>
    </ContainerHomGradientBorder>
  )
}
